import React from 'react';
import propTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import Input from '@hobs/components/Input';
import { RaisedButton } from '@hobs/components/Buttons';

import './UpdateInfoForm.scss';
import { createLoadingSelector } from '@hobs/utils/loading';
import { phoneRegex } from '@hobs/validations';
import * as Yup from 'yup';
import { H1 } from '@hobs/components/Headings';

class UpdateInfoForm extends React.PureComponent {
  state = {
    phone: ''
  };

  updateSchema = Yup.object().shape({
    phone: Yup.string()
      .matches(phoneRegex, {
        message: 'Please enter a valid phone number',
        excludeEmptyString: true
      })
      .min(6, 'Phone number cannot be shorter than 6 symbols')
      .max(100, 'Phone number cannot be longer than 100 symbols')
      .required()
  });

  async componentDidMount() {
    await this.setInformation();
  }

  setInformation = async () => {};

  onSubmit = async values => {
    const results = await this.props.updatePeriodicInfo(values);
    if (results.success) {
      return this.props.history.push('/');
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className="update-info-form">
        <Formik
          enableReinitialize={true}
          initialValues={{ phone: this.state.phone }}
          onSubmit={this.onSubmit}
          validationSchema={this.updateSchema}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="update-info-form--heading">
                <H1>{t('Update information')}</H1>
              </div>
              <Field name="phone" type="text" component={Input} large>
                {t('Phone number')}
              </Field>

              <RaisedButton
                large
                type="submit"
                disabled={isSubmitting || isLoading}
              >
                Update
              </RaisedButton>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

UpdateInfoForm.propTypes = {
  history: propTypes.object,
  t: propTypes.func,
  match: propTypes.object
};

const isLoading = createLoadingSelector([
  'Parties/Current',
  'Users/GetCurrent',
  'Users/UpdatePeriodicInfo'
]);

export default UpdateInfoForm;
